import { createRouter, createWebHistory } from 'vue-router';
import { useUserStore } from '@/stores/useUserStore';
import { useAppStore } from '@/stores/useAppStore';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/HomeView/HomeView.vue'),
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () =>
      import(
        /* webpackChunkName: "pricing" */ '../../lib/views/PricingView/PricingView.vue'
      ),
  },
  {
    path: '/payment-success',
    name: 'paymentSuccess',
    component: () =>
      import(
        /* webpackChunkName: "paymentSuccess" */ '../../lib/views/payments/PaymentSuccessView/PaymentSuccessView.vue'
      ),
  },
  {
    path: '/payment-error',
    name: 'paymentError',
    component: () =>
      import(
        /* webpackChunkName: "paymentError" */ '../../lib/views/payments/PaymentErrorView/PaymentErrorView.vue'
      ),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '../../lib/views/SettingsView/SettingsView.vue'
      ),
  },
  {
    path: '/auth/google/callback',
    name: 'googleAuth',
    component: () =>
      import(
        /* webpackChunkName: "googleAuth" */ '../../lib/views/GoogleAuth/GoogleAuth.vue'
      ),
  },
  {
    path: '/ai-model',
    name: 'aiModel',
    component: () =>
      import(
        /* webpackChunkName: "aiModel" */ '../views/AiModelView/AiModelView.vue'
      ),
    meta: {
      authOnly: true,
    },
  },
  {
    path: '/admin/users',
    name: 'usersList',
    component: () =>
      import(/* webpackChunkName: "admin" */ '../../lib/views/admin/UsersList.vue'),
    props: true,
    meta: {
      authOnly: true,
      adminOnly: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return { selector: to.hash };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

const checkIsAllLoaded = () => {
  const userStore = useUserStore();

  return (
    userStore.isAuthenticated
      ? userStore.userStatus.type === 'success'
      : true
  );
};

router.beforeEach(async (to, from) => {
  const appStore = useAppStore();
  const userStore = useUserStore();

  if (!checkIsAllLoaded()) {
    await new Promise((res) => {
      appStore.toggleAppLoader(true);

      const interval = setInterval(() => {
        if (checkIsAllLoaded()) {
          clearInterval(interval);
          appStore.toggleAppLoader(false);

          res();
        }
      }, 100);
    });
  }

  if (
    to.matched.some((record) => record.meta.authOnly) &&
    !userStore.isAuthenticated
  ) {
    return {
      name: from?.name || 'home',
      params: {
        nextRoute: to.name,
        needsAuth: true,
      },
    };
  }

  if (
    (to.matched.some((record) => record.meta.adminOnly) &&
      !userStore.isAdmin) ||
    (to.matched.some((record) => record.meta.premiumOnly) &&
      !userStore.hasPremium)
  ) {
    return {
      name: 'home',
    };
  }

  if (
    to.matched.some((record) => record.meta.withLimit) &&
    userStore.user.limit <= 0
  ) {
    return {
      name: 'home',
      params: { showLimitsModal: true },
    };
  }
});

export default router;
